import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { Ditta, Iaddress, Stati, Users, DittaService,
   StatiService } from 'my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';

@Component({
  selector: 'app-ditta-create',
  templateUrl: './ditta-create.component.html',
  styleUrls: ['./ditta-create.component.css']
})
export class DittaCreateComponent implements OnInit {
  user: Users;
  id: string;
  ditta: Ditta;
  stati: Observable<Stati[]>;
address: Iaddress;
  constructor(
    public dialog: MatDialog,
    private dittaservice: DittaService,
    private usersservice: UsersService,
    private router: Router,
    private db: AngularFirestore,
    private route: ActivatedRoute,
    private statiservice: StatiService,


  ) { }
  openDialog(): void {
    const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
      if (result) {
        this.address = result;
        this.ditta.address = this.address;

        console.log('The dialog was closed');
        console.log(this.address);

      }
    });
  }


  onSubmit() {

    this.user.ditta = this.ditta;
    this.usersservice.update(this.user).then(() => {
      this.router.navigate(['/myuser', 'ditta', 'details', this.id]);
      console.log(this.user);
     });
       }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.stati = this.statiservice.listAttivi();
    this.usersservice.details(this.id).subscribe(u => {
  this.user = u;
  if(this.user.ditta){

  } else {
    this.ditta = {
      ragionesociale: null,
  partitaiva: null,
  codicefiscale: null
};
  }
});


        }




}
